module.exports = __webpack_public_path__ + "assets/images/coin-5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-5.png
// module id = 1507
// module chunks = 1